var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttempts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1288 0C18.702 0 18.2927 0.169552 17.9909 0.471357C17.6891 0.773162 17.5195 1.1825 17.5195 1.60931V12.8745C17.5195 13.3013 17.6891 13.7107 17.9909 14.0125C18.2927 14.3143 18.702 14.4838 19.1288 14.4838L30.394 14.4838C30.8209 14.4838 31.2302 14.3143 31.532 14.0125C31.8338 13.7107 32.0034 13.3013 32.0034 12.8745C32.0034 9.45997 30.6469 6.18529 28.2325 3.77085C25.8181 1.35642 22.5434 0 19.1288 0Z",
    fill: "#698192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7998 6.40234C10.2683 6.40234 7.79354 7.15304 5.68862 8.5595C3.5837 9.96596 1.94312 11.965 0.974333 14.3039C0.00554593 16.6427 -0.247933 19.2164 0.245951 21.6993C0.739834 24.1822 1.9589 26.4629 3.74898 28.253C5.53907 30.0431 7.81978 31.2621 10.3027 31.756C12.7856 32.2499 15.3592 31.9964 17.6981 31.0276C20.037 30.0589 22.036 28.4183 23.4425 26.3134C24.8489 24.2084 25.5996 21.7337 25.5996 19.2022C25.5996 18.3185 24.8833 17.6022 23.9997 17.6022H15.9998C15.1161 17.6022 14.3998 16.8858 14.3998 16.0022V8.00232C14.3998 7.11868 13.6835 6.40234 12.7998 6.40234Z",
    fill: "#0C3450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempts);
export default __webpack_public_path__ + "static/media/Attempts.96a483319fc113fbd3cccd461ee1f99a.svg";
export { ForwardRef as ReactComponent };